import { Subject } from 'rxjs';

import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { snDetailExpand, snFadeIn, snFadeOut, snListStagger } from '@lib/common/animations';
import { SnTableBaseComponent } from 'libs/core/src/lib/components/table-base.component';

import { SnLpr } from '../../api';
import { LprHotlistsPlatesDialogComponent } from '../lpr-hotlists-plates-dialog/lpr-hotlists-plates-dialog.component';

@Component({
  selector: 'fs-lpr-hotlists-table',
  templateUrl: './lpr-hotlists-table.component.html',
  styleUrls: ['./lpr-hotlists-table.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut, snDetailExpand],
})
export class LprHotlistsTableComponent extends SnTableBaseComponent<SnLpr> implements OnDestroy {
  private readonly _destroy$ = new Subject();

  constructor(private readonly _dialog: MatDialog) {
    super();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public trackBy(index: number, item: SnLpr): any {
    return item.id;
  }

  public showHotlist(hotlist: any): void {
    this._dialog.open(LprHotlistsPlatesDialogComponent, {
      data: {
        hotlists: this.items,
        hotlist,
      },
      width: '1080px',
    });
  }
}
